import {
  AgxRow,
  AgxColumn,
  DropdownOption,
  AgxTextInput,
  AgxTypography,
  AgxDropdown,
  AgxDatePicker,
} from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import moment from 'moment';
import {
  PartnershipDetails,
  PartnershipDetailsPartnershipLevel,
} from '@urbanx/agx.agencies.client';
import { PartnershipLevelOptions } from './PartnershipLevelOptions';
type Props = {
  partnershipDetails: PartnershipDetails;
  onChange: (newDetails: PartnershipDetails) => void;
  partnershipDefaultValue: DropdownOption;
};

const PartnershipInformation = ({ partnershipDetails, onChange }: Props) => {
  return (
    <AgxColumn gap="spacing-xl" fill>
      <AgxRow>
        <AgxTypography id="agx-accordion-value" size="large" type="title">
          Partnership Information
        </AgxTypography>
      </AgxRow>
      <Panel>
        <AgxColumn gap="spacing-4xl" fill>
          <AgxRow gap="spacing-3xl" fill>
            <AgxDatePicker
              id={'partnershipAnniversaryDate'}
              optionalText=""
              onChange={(value) =>
                onChange({
                  ...partnershipDetails,
                  anniversaryDate: value ? new Date(value) : undefined,
                })
              }
              value={
                partnershipDetails.anniversaryDate
                  ? moment(partnershipDetails.anniversaryDate).toDate()
                  : new Date()
              }
              label="Anniversary Date"
              required
              stretch
            />

            <AgxDropdown
              id="partnershipLevel"
              options={PartnershipLevelOptions}
              selected={partnershipDetails.partnershipLevel ?? ''}
              label="Partnership Level"
              required
              onChange={(value: string) => {
                onChange({
                  ...partnershipDetails,
                  partnershipLevel: value as PartnershipDetailsPartnershipLevel,
                });
              }}
              hideOptionalText
            />

            <AgxTextInput
              type="currency"
              noDecimalPoints
              id="partnershipTargetAdjustment"
              defaultValue={partnershipDetails.targetLevelAdjustment?.toString() ?? ''}
              label="Target adjustment"
              stretch
              onInputValueChange={({ value }) => {
                const numericValue = Number(value.replace(/[^0-9.-]+/g, ''));
                onChange({
                  ...partnershipDetails,
                  targetLevelAdjustment: isNaN(numericValue) ? undefined : numericValue,
                });
              }}
            />
          </AgxRow>
        </AgxColumn>
      </Panel>
    </AgxColumn>
  );
};

export default PartnershipInformation;
